import { Injectable } from "@angular/core";
import { DwContextDefinition, DwAttributeType, DwControlType, DwQueryMdAttribute, DwMdAttribute, DwFieldType, DwUserContextDynamicHandler, DwUserExtendedData } from "@devwareapps/devware-cap";
import { Observable } from "rxjs";
import { AdminManagerService } from "../services/admin-manager.service";

// TODO: Replace 0 with the actual UserType lookup ID once database schema is set up and metadata is generated.
const USER_TYPE_LOOKUP_ID = 0;

@Injectable()
export class FitnessUserContextCustomizerService implements DwUserContextDynamicHandler {

    constructor(private adminManagerService: AdminManagerService) {

    }

    setupUserContextDefinition(userContextDef: DwContextDefinition, userExtendedData: DwUserExtendedData): void | Observable<any> {
        this.addProperty(userContextDef.attributes, 'UserTypeMode', 'User Type Mode', DwAttributeType.Integer, DwControlType.DropDownList, USER_TYPE_LOOKUP_ID);
    }

    customizeUserContext(userContext: any, context: any, contextData: any) {
        const fitnessUser = this.adminManagerService.getFitnessUser(userContext);

        userContext.UserTypeMode = fitnessUser.UserTypeId;
        userContext.UserTypeId = fitnessUser.UserTypeId;

        return userContext;
    }

    protected addProperty(attributes: DwQueryMdAttribute[], name: string, display: string, attrType?: DwAttributeType, controlType?: DwControlType, lookupId?: number): DwQueryMdAttribute {
        let attr: DwMdAttribute = {
            AttributeName: name,
            Display: display,
            AttributeType: attrType || DwAttributeType.Text,
            MetaDataControlTypeId: controlType || DwControlType.Textbox,
            MetaDataLookupId: lookupId,
            IsLookup: !!lookupId,
        };

        let mdQueryAttr: DwQueryMdAttribute = {
            Attribute: attr,
            FieldType: DwFieldType.Standard,
            AttributeDisplay: attr.Display,
            AttributeType: attr.AttributeType,
            AttributeName: attr.AttributeName,
            HasDisplayField: false,
            DisplayAttributeName: attr.AttributeName,
        };

        attributes.push(mdQueryAttr);

        return mdQueryAttr;
    }
}
